import type { TOC } from '@ember/component/template-only';
import { parseInlineLinks } from '../utils/inline-links.ts';

interface InlineLinkTextSignature {
  Args: {
    /** Admin-authored plain text; `[label](https://…)` runs render as links that open in a new tab. */
    text: string;
  };
}

const InlineLinkText: TOC<InlineLinkTextSignature> = <template>
  {{~#each (parseInlineLinks @text) as |segment|~}}
    {{~#if segment.href~}}
      <a
        href={{segment.href}}
        target="_blank"
        rel="noopener noreferrer"
        class="app-text-link app-text-link--inline"
      >{{segment.text}}</a>
    {{~else~}}
      {{segment.text}}
    {{~/if~}}
  {{~/each~}}
</template>;

export default InlineLinkText;
